
const ImageGallery = (target) => {
  const mainImage = target.querySelector(".product__image img");
  const imageThumbnails = target.querySelectorAll(".product__image-thumbnail");

  const method = {
    init: () => {
      imageThumbnails.forEach((thumb) => {
        thumb.addEventListener("click", method.onClick);
      });
    },
    onClick: (e) => {
      const targetImage = e.target;
      const imageUrl = targetImage.getAttribute("data-imageUrl");

      method.cleanupClasses();
      targetImage.classList.add("product-image--selected");
      mainImage.src = imageUrl;
    },
    cleanupClasses: () => {
      imageThumbnails.forEach((thumb) => {
        thumb.classList.remove("product-image--selected");
      });
    },
  };

  method.init();
};

export default ImageGallery;
